import { Grid, Paper, Box, Typography } from "@mui/material";
import Loader from "Components/Loader";
import ImgPath from "Constants/Imgs";
import { RouteUrls } from "Constants/RouteUrls";
import { DashboardCardType } from "DataTypes/Dashboard.type";
import { UserInitialStateType } from "DataTypes/Redux";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CaseApi from "Service/Case.api";
import ContactUsDialog from "./ContactUsDialog";
import StarIcon from '@mui/icons-material/Star';
import {
  SupportAgent,
  VerifiedUser,
  AssignmentInd,
  SettingsPhone,
  AdminPanelSettings,
  Dashboard,
  Groups,
  FactCheck,
  Payments,
  CurrencyRupee
} from '@mui/icons-material';

const DashboardCards = () => {
  const navigate = useNavigate();
  const [cards, setCards] = useState<DashboardCardType[]>([]);
  const [loading, setLoading] = useState(false);
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );

  const cardData = [
    // {
    //   title: "Earn & Payments",
    //   count: 0,
    //   icon: ImgPath.EarnAndPayIcon,
    //   path: "#",
    // },
    // {
    //   title: "Applicaion & Calender",
    //   // count: 0,
    //   icon: ImgPath.ApplicationCalIcon,
    //   path: "#",
    // },
    {
      title: "Contact Us",
      // count: 0,
      // icon: ImgPath.ContactUsIcon,
     icon: <SupportAgent sx={{ fontSize: 45, color: '#1976d2' }} />,
      path: "contact",
    },
    // ...(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN"
    //   ? [
    //       {
    //         title: "Corporate Users",
    //         // count: 0,
    //         icon: ImgPath.KnowledgeBankIcon,
    //         path: `/${RouteUrls.corporateList}`,
    //       },
    //     ]
    //   : []),
    ...(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN"
      ? [
          {
            title: "Verify Professional Users",
            // count: 0,
            // icon: ImgPath.KnowledgeBankIcon,
            icon: <VerifiedUser sx={{ fontSize: 45, color: '#2e7d32' }} />,
            path: `/${RouteUrls.professionalUsers}`,
          },
        ]
      : []),
    ...(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN"
      ? [
          {
            title: "Assign professional to case",
            // count: 0,
            // icon: ImgPath.KnowledgeBankIcon,
            icon: <AssignmentInd sx={{ fontSize: 45, color: '#0288d1' }} />,
            path: `/${RouteUrls.AssignProfessional}`,
          },
        ]
      : []),
      ...(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN"
      ? [
          {
            title: "Hotline",
            // count: 0,
            // icon: ImgPath.KnowledgeBankIcon,
            icon: <SettingsPhone sx={{ fontSize: 45, color: '#d32f2f' }} />,
            path: `/${RouteUrls.Hotline}`,
          },
        ]
      : []),
       ...(myInfo.userType === "SUPERADMIN"
      ? [
          {
            title: "Admin User Management",
            // count: 0,
            // icon: ImgPath.KnowledgeBankIcon,
            icon: <AdminPanelSettings sx={{ fontSize: 45, color: '#7b1fa2' }} />,
            path: `/${RouteUrls.AdminUserManagement}`,
          },
        ]
      : []),
      ...(myInfo.userType === "SUPERADMIN"
      ? [
          {
            title: "Case Dashboard",
            // count: 0,
            // icon: ImgPath.ActiveOrdersIcon,
            icon: <Dashboard sx={{ fontSize: 45, color: '#455a64' }} />,
            path: `/${RouteUrls.CaseDashboard}`,
          },
        ]
      : []),
      ...(myInfo.userType === "SUPERADMIN"
      ? [
          {
            title: "All Users",
            // count: 0,
            // icon: ImgPath.ActiveOrdersIcon,
            icon: <Groups sx={{ fontSize: 45, color: '#ed6c02' }} />,
            path: `/${RouteUrls.AllUsers}`,
          },
        ]
      : []),
      ...(myInfo.userType === "SUPERADMIN"
      ? [
          {
            title: "Payment Refund",
            // count: 0,
            // icon: <Groups sx={{ fontSize: 45, color: '#ed6c02' }} />,

            // icon: <CurrencyExchange sx={{ fontSize: 45, color: '#c62828' }} />,
            icon: ImgPath.ActiveOrdersIcon,
            // icon: <CurrencyExchange sx={{ fontSize: 45, color: '#c62828' }} />,
            path: `/${RouteUrls.PaymentProcess}`,
          },
        ]
      : []),
            ...(myInfo.userType === "ADMIN"
      ? [
          {
            title: "Initiate Professional Payouts",
            // count: 0,
            // icon: <Groups sx={{ fontSize: 45, color: '#ed6c02' }} />,

            icon: <CurrencyRupee sx={{ fontSize: 45, color: '#2e7d32' }} />,
            path: `/${RouteUrls.professionalUserListing}`,
          },
        ]
      : []),
       ...(myInfo.userType === "SUPERADMIN"
      ? [
          {
            title: "Verify Professional Payouts",
            // count: 0,
            icon: <CurrencyRupee sx={{ fontSize: 45, color: '#0288d1' }} />,
            path: `/${RouteUrls.SuperAdminApproval}`,
          },
        ]
      : []),
    ...(myInfo.userType === "ADMIN"
      ? [
        {
          title: "Reward Redeem Requests",
          // count: 0, // You can fetch this count from your API later
          icon: <StarIcon sx={{ fontSize: 45, color: '#0288d1' }} />,
          path: `/${RouteUrls.RewardRedeemRequests}`,
        },
      ]
      : []),
  ];
  useEffect(() => {
    handleOnLoad();
  }, []);

  const handleOnLoad: () => void = async () => {
    setLoading(true);
    const res = await CaseApi.getDashboardCount();
    if (res?.success) {
      const newArr: DashboardCardType[] = res?.data
        ?.map((el: any) => {
          return {
            title: `${el?.orderTypeName} Orders`,
            count: el?.caseCount,
            icon: getCardIconByOrderTypeId(el?.orderTypeId),
            path: getCardPath(el),
          };
        })
        ?.filter((el: DashboardCardType) => (el.count ?? 0) > 0); // filter out cards with count 0
      setCards([...newArr, ...cardData]);
    }
    else {
      // If API fails, still show the static admin cards
        setCards(cardData);
    }
    setLoading(false);
  };

  const getCardPath: (el: any) => string = (el) => {
    if (el?.orderTypeName === "Active") {
      return `/${RouteUrls.chat}`;
    } else {
      return `/${RouteUrls.chat}/${el?.orderTypeId}`;
    }
  };

const getCardIconByOrderTypeId = (orderTypeId: number): string => {
  try {
    return require(`../../Assets/Imgs/DashboardIcons/${"Icon"+orderTypeId}.png`);
  } catch {
    return require(`../../Assets/Imgs/DashboardIcons/defaultIcon.png`); // fallback image
  }
};

  return (
    <Box overflow={"auto"} height={"100%"} >
    <Grid container spacing={3} px={2}>
      {loading ? (
        <Loader />
      ) : (
        cards.map(({ title, count, icon, path }) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={title}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                borderRadius: 2,
                height: "100%",
                boxShadow: 3,
                cursor: "pointer",
              }}
            >
              {/* <Box
                component="img"
                src={icon}
                alt={title}
                sx={{
                  width: { xs: 50, sm: 60, md: 70 }, // responsive: 50px (xs), 60px (sm), 70px (md+)
                  height: { xs: 50, sm: 60, md: 70 },
                  flexShrink: 0,
                }}
              /> */}
              {/* 🎯 LOGIC FIX START: Handle both Image Path and MUI Icon Component */}
{/* Icon Container */}
          <Box
            sx={{
              width: 64,
              height: 64,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              mr: 2,
              borderRadius: "12px",
              backgroundColor: typeof icon === 'string' ? 'transparent' : '#f0f4f8',
            }}
          >
            {typeof icon === "string" ? (
              <Box component="img" src={icon} alt={title} sx={{ width: "80%", height: "80%" }} />
            ) : (
              icon // Renders the MUI Icon Component
            )}
          </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  flex: 1,
                }}
                onClick={() => {
                  if (path === "contact") {
                    setContactDialogOpen(true);
                  } else if (path && path !== "#") {
                    navigate(path);
                  }
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 500,
                    fontSize: "1rem",
                    mb: 0.5, // margin-bottom
                    textAlign: "center",
                    overflowWrap: "break-word", // ensures consistent wrapping across browsers
                    whiteSpace: "normal", // allows line wrapping
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    mb: 0.5, // margin-bottom
                    textAlign: "center",
                  }}
                >
                  {count}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))
      )}

      <ContactUsDialog
        open={contactDialogOpen}
        onClose={() => setContactDialogOpen(false)}
      />
    </Grid>
    </Box>
  );
};

export default DashboardCards;
